// DS: IL4
// from GDrive
import React from 'react';
export class SheetBanned extends React.PureComponent {
    render() {
        return /*#__PURE__*/ React.createElement("svg", {
            width: "88",
            height: "88",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ React.createElement("g", {
            fill: "#000"
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M66.95 59.05a.996.996 0 0 0-1.41 0L62 62.59l-3.54-3.54a.996.996 0 1 0-1.41 1.41L60.59 64l-3.54 3.54a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29L62 65.41l3.54 3.54c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 0 0 0-1.41L63.41 64l3.54-3.54a.996.996 0 0 0 0-1.41z"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M19 18h29v14h14v15h2V30.59L49.41 16H17v60h32v-2H19V18zm31 1.41L60.59 30H50V19.41z"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M53 38H28c-.55 0-1 .45-1 1s.45 1 1 1h25c.55 0 1-.45 1-1s-.45-1-1-1zM28 32h10c.55 0 1-.45 1-1s-.45-1-1-1H28c-.55 0-1 .45-1 1s.45 1 1 1zM53 46H28c-.55 0-1 .45-1 1s.45 1 1 1h25c.55 0 1-.45 1-1s-.45-1-1-1zM48 54H28c-.55 0-1 .45-1 1s.45 1 1 1h20c.55 0 1-.45 1-1s-.45-1-1-1zM45 64c.55 0 1-.45 1-1s-.45-1-1-1H28c-.55 0-1 .45-1 1s.45 1 1 1h17zM62 77c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13zm0-2c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z"
        })));
    }
}

//# sourceMappingURL=SheetBanned.js.map